<dx-pivot-grid #grid
               [allowSortingBySummary]="true"
               [allowSorting]="true"
               [allowFiltering]="true"
               [allowExpandAll]="true"
               [showBorders]="false"
               [showColumnGrandTotals]="false"
               [dataSource]="dataSource">
  <dxo-export [enabled]="true" fileName="les-interventions-du-transport"></dxo-export>
  <dxo-field-chooser [enabled]="true"></dxo-field-chooser>
</dx-pivot-grid>
